import { httpLogger as log } from 'common/services/logging/loggers';
import * as Sentry from '@sentry/browser';
/**
 * Http Interceptor for logging REST calls into the console.
 */
angular.module('services')
    .factory('RetryRequestInterceptor', ($injector, $q, $timeout) => {

        const MAX_RETRIES = 3;
        const REQUEST_DELAY = 1000; // in milliseconds;
        const retryData = {
            attempts: 0,
            lastErrorCode: 'N/A',
        };

        return {
            responseError(response) {

                // because there is an error appearing in IE
                // where the response.config seems to be undefined sometimes
                if (response && response.config) {

                    // disable retry mechanism for ocp flow
                    if (response.config.url.indexOf('/payments/') > -1) {

                        return $q.reject(response);

                    }

                    response.config.cwRetry =
                        response.config.cwRetry || Object.assign({}, retryData);

                    const errorCode = String(response.status);
                    const isServerError = (errorCode.lastIndexOf('5', 0) === 0 && errorCode.length === 3);
                    const shouldRetryRequest =
                        (isServerError) ||
                        errorCode === '-1' ||
                        errorCode === '0';


                    if (shouldRetryRequest && response.config.cwRetry.attempts < MAX_RETRIES && response.config.method === 'GET') {

                        return $timeout(() => {

                            const $http = $injector.get('$http');
                            response.config.cwRetry.attempts += 1;
                            response.config.cwRetry.lastErrorCode = errorCode;

                            log.log({
                                type: 'RCV HTTP REST',
                                cmd: `SERVER.ERROR ${response.config.method} ${response.config.url}`,
                                data: {
                                    msg: `Request failed. This is retry attempt number ${response.config.cwRetry.attempts}`,
                                },
                            });

                            return $http(response.config);

                        }, REQUEST_DELAY);

                    }

                }

                if (response
                    && response.config
                    && response.config.cwRetry
                    && response.config.cwRetry.attempts === MAX_RETRIES
                ) {

                    Sentry.withScope((scope) => {

                        scope.setLevel('error');
                        Sentry.captureMessage(`Request retrying failed for ${response.config.url} with errorCode: ${response.config.cwRetry.lastErrorCode}`);

                    });

                }

                // !!Important Must use promise api's q.reject()
                // to properly implement this interceptor
                // or the response will go the success handler of the caller
                return $q.reject(response);

            },
        };

    });



// WEBPACK FOOTER //
// ./scripts/common/services/RetryRequestInterceptor.js